import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../../components/en/Navbar";
import Footer from "../../components/en/Footer";
import Cta from "../../components/en/CtaMarketing";

import "../../styles/common.css";
import "../../styles/service.css";

import imgIssue01 from "../../img/common/illustration_service_marketing.svg";
import imgfeature01 from "../../img/marketing/img_feature_01.png";
import imgfeature02 from "../../img/marketing/img_feature_02.png";
import imgfeature03 from "../../img/marketing/img_feature_03.png";
import imgfeature04 from "../../img/marketing/img_feature_04.png";


const MarketingEn = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='marketing'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>Marketing Support</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/en">Home</a></li>
                <li aria-current="page">Marketing Support</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='issue'>
          <div className='flex marketing-issue'>
            <div className='marketing-issue__text'>
              <h2>At LOGOT, we offer outsourcing services aimed at web customer acquisition and inquiry generation.</h2>
              <p>A website alone cannot generate sufficient inquiries just by being published.<br />Continuous operation and appropriate marketing measures are essential to "nurture" it.<br />However, specialized web marketing knowledge is required to steadily grow a website and raise it to a certain level.<br />At LOGOT, we provide strategic measures to increase inquiries and strengthen customer acquisition, leading your website to a state of success.<br />We will manage your site on your behalf to achieve stable inquiry acquisition and web customer acquisition.</p>
            </div>
            <div className='marketing-issue__img'>
              <img src={imgIssue01} alt="" />
            </div>
          </div>
          <div className='issue-text'>
            <p>First, let's<br className='sp-only' /><span>"Get web customer acquisition on track"</span><br />For that, we recommend<br className='sp-only' /><span>outsourcing site management</span>.</p>
          </div>
        </section>
        <section className='feature'>
          <div className="title">
            <p className='title-lead'>FEATURE</p>
            <h2>Four Features of Marketing Support</h2>
          </div>
          <div className='feature-box flexBox-imgText'>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>01</span></p>
                <h3>Creating and Managing LPs with Clear Objectives</h3>
                <p className='feature-item__detail'>LOGOT creates and supports the operation of landing pages (LPs) designed to deliver results. We analyze target behavior and design effective layouts and CTAs. By utilizing A/B testing, we continuously improve and optimize the pages to generate inquiries.<br />Additionally, we collaborate with advertising operations and SEO measures to increase natural traffic, achieving stable results. Our strategic LP management supports the growth of your business.</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature01} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature02} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>02</span></p>
                <h3>Effectively Utilizing Corporate SNS to Enhance Brand Awareness</h3>
                <p className='feature-item__detail'>LOGOT's SNS management service effectively utilizes corporate SNS to enhance brand awareness. Once the operation is on track, it is designed to allow customers to manage it themselves.<br />Rather than relying on temporary effects, we use long-term strategies such as posting strategies and influencer marketing. Based on data analysis, we propose optimal posting content, increasing brand fans and achieving stable SNS management.</p>
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>03</span></p>
                <h3>Ensuring Effective User Approach</h3>
                <p className='feature-item__detail'>At LOGOT, we manage Google ads and SNS ads (Facebook, Instagram, X, LinkedIn, etc.), reaching targets with optimal advertising strategies and achieving cost-effective customer acquisition.<br />We formulate keywords through market research and competitive analysis and reflect them in the ads.</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature03} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature04} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>04</span></p>
                <h3>Utilizing the Latest Technologies (DX, AI) for Task Outsourcing</h3>
                <p className='feature-item__detail'>LOGOT offers task outsourcing utilizing the latest technologies (DX, AI), achieving operational efficiency and improved results. We handle a wide range of tasks, from automating email marketing and optimizing target lists to AI-driven blog posts and content creation.<br />By leveraging DX, we reduce human costs while executing more precise marketing measures. We support your company's growth with strategy design and operation based on data analysis.</p>
              </div>
            </div>
          </div>
        </section>
        <Cta></Cta>
        <section className='flow'>
          <div className="title">
            <p className='title-lead'>FLOW</p>
            <h2>Branding Support Process</h2>
          </div>
          <ol className='flow-box'>
            <li>
              <div className='flow-box__number'><p>1</p></div>
              <div className='flow-box__text'>
                <h3>Preliminary Preparation and Hearing</h3>
                <p>Before starting the project, LOGOT conducts a detailed hearing about the ideal brand image six months later and the current issues the company is facing.<br />If the website or SNS is already in operation, we conduct market research, competitive analysis, and user insight research to prepare for the strategy to leverage the brand's strengths.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>2</p></div>
              <div className='flow-box__text'>
                <h3>Kickoff Meeting</h3>
                <p>Based on the data collected in advance, we delve into the needs of the target market and the differentiation points from competitors, defining the "worldview" of the brand.<br />We also decide on the direction of localization strategy, content design, and visual identity, creating a six-month roadmap.<br />We propose the best approach to maximize brand value by concretizing the strategy.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>3</p></div>
              <div className='flow-box__text'>
                <h3>Plan Execution</h3>
                <p>At LOGOT, we not only implement measures but also analyze the effectiveness of each measure with data, proposing improvement measures to maximize the growth of the company and brand.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>4</p></div>
              <div className='flow-box__text'>
                <h3>Effect Measurement and Report Creation</h3>
                <p>We summarize the analysis results of site access and create a report, sharing information once a month. We also review the effectiveness of the measures implemented up to the previous month and consider improvement plans, reflecting them in the plan for the following month.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>5</p></div>
              <div class='flow-box__text'>
                <h3>Monthly Meetings</h3>
                <p>We report the results of the marketing measures up to the previous month and propose and decide on the plan for the following month based on that content. We also share the progress towards the final goal.</p>
              </div>
            </li>
          </ol>
        </section>
        <section className='qa'>
          <div className="title">
            <p className='title-lead'>Q&A</p>
            <h2>Frequently Asked Questions</h2>
          </div>
          <ul className='qa-box'>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>Is there a minimum contract period?</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>Yes, there is a minimum contract period of six months from the contract month.</p></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>Can we contract for a site created by another company?</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>Yes, it is possible. However, if the site was not built by us, there may be some cases where it is difficult to respond due to unknown specifications and design details. Please understand this in advance.</p></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>What are the specific contents of marketing support?</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>Based on the issues heard in advance, we conduct multifaceted research, including market analysis and access analysis, and propose "future brand operation policies" and "necessary measures and improvement plans".<br />The proposal content varies depending on the situation, but if the issue is the number of accesses, we propose "which articles to rewrite?", and if the issue is the number of inquiries, we propose "measures to increase inquiries", etc. We propose not only strategies but also specific tactics, and decide on future policies.</p></dd>
              </dl>
            </li>
          </ul>
        </section>
        <Cta></Cta>
      </main >
      <Footer></Footer>
    </>
  );
};

export default MarketingEn;